import Vue from "vue";
import dateFormats, { DEFAULT_MONTH_FORMAT } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatMonth = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_MONTH_FORMAT);
};

Vue.filter("formatMonth", filterFormatMonth);
